import angular from 'angular'
import coverPage from './view/image.html'

const contractImage = angular.module('app.input.electronImage.contractImage', [])

export default contractImage.name

class ContractImageCtrl {
    constructor(httpRequest, logger, sweetalert, $scope) {
        // {currentObj, list, total, currentPage}
        this.pageInfo = {
            list: [],
        }
        function generatePageInfo(list, pageNum) {
            const currentPage = pageNum < 1 ? 1 : pageNum
            return {
                list,
                currentObj: list[currentPage - 1],
                total: list.length,
                currentPage,
            }
        }
        this.$onChanges = function onchanges() {
            if (this.contractInfo) {
                this.pageInfo = generatePageInfo(this.contractInfo.contractFileList, 1)
            }
        }
        this.deleteImage = function deleteImage() {
            sweetalert.confirm('删除提醒', '是否删除该条合同影像？').then(() => {
                httpRequest.post_deleteContractFile(this.pageInfo.currentObj).then(() => {
                    this.contractInfo.contractFileList.splice(this.pageInfo.currentPage - 1, 1)
                    this.pageInfo = generatePageInfo(this.contractInfo.contractFileList, this.pageInfo.currentPage - 1)
                    logger.logSuccess('删除成功')
                    $scope.$emit('contractStatisticChange')
                })
            })
        }
    }
}

ContractImageCtrl.$inject = ['httpRequest', 'logger', 'sweetalert', '$scope']
contractImage.controller('contractImageCtrl', ContractImageCtrl)
contractImage.component('contractImage', {
    template: coverPage,
    bindings: {
        contractInfo: '<',
        readonly: '<',
    },
    controller: 'contractImageCtrl',
})



// WEBPACK FOOTER //
// ./src/app/input/electronImage/contractEntering/contractImage.js